import React from 'react';
import { FcGoogle } from 'react-icons/fc';

interface IconProps {
  color?: string;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
}

const GoogleIcon: React.FC<IconProps> = ({ size, width = 28, height = 28, className }) => (
  <FcGoogle aria-hidden="true" className={className} size={size} width={size ?? width} height={size ?? height} />
);

export default GoogleIcon;
